
;( function( window, $ ) {

    /**
     * Ensphere Sortable
     * @author Luke Snowden
     * @date 8/05/2017
     *
     * @param options
     * @returns {*}
     */
    $.fn.ensphereSortable = function( options )
    {

        var _options = $.extend({
            indentSize : 40,
            dragHandle : '.drag-handle',
            bodyScrollFix : true,
            collapsibleMenu : false
        }, options );

        /**
         *
         * @param elm
         * @param options
         * @returns {api}
         * @constructor
         */
        var Sortable = function( elm, options )
        {
            var menu = $(elm);

            var items = [];

            var moving = null;

            /**
             * Set Parent To All
             */
            var setParentToAll = function()
            {
                items.forEach( function( itemObject ) {
                    itemObject.setParent();
                });
            };

            /**
             * Set Order To All
             */
            var setOrderToAll = function()
            {
                items.forEach( function( itemObject ) {
                    itemObject.setOrder();
                });
            };

            /**
             * Sort Items After Drop
             */
            var sortItemsAfterDrop = function()
            {
                items.forEach( function( itemObject ) {
                    itemObject.setMaxIndent();
                });
            };

            /**
             * Set Offset Of All Items
             */
            var setOffsetsOfAllItems = function()
            {
                items.forEach( function( itemObject ) {
                    var _item = itemObject.item;
                    itemObject.positions = {
                        x : _item.position().left,
                        y : _item.position().top,
                        height : _item.outerHeight()
                    };
                });
            };

            /**
             * Check Horizontal Tabbing
             */
            var checkHorizontalTabbing = function()
            {
                var indent = ( Math.floor( moving.relCords.x / options.indentSize ) - 1);
                indent = indent < 0 ? 0 : indent;
                indent = indent > moving.itemObject.maxIndent ? moving.itemObject.maxIndent : indent;
                if( indent !== moving.itemObject.indent ) {
                    moving.itemObject.indent = indent;
                    moving.itemObject.indented();
                }
            };

            /**
             * Get THe Max Indent For Item
             * @param itemObject
             * @returns {number}
             */
            var getMaxIndentFor = function( itemObject )
            {
                var maxIndent = 0;
                var prevItem = itemObject.getWorkableItem().prevAll('.sortable--item').not('.sortable--moving').not('.sortable--clone').first();
                var prevItemObject = prevItem.data( 'sortable' );
                if( prevItemObject.indent < itemObject.indent ) {
                    maxIndent = prevItemObject.indent + 1;
                } else if( prevItemObject.indent === itemObject.indent ) {
                    maxIndent = itemObject.indent + 1;
                } else {
                    maxIndent = prevItemObject.indent + 1;
                }
                return maxIndent;
            };

            /**
             * Check Vertical Cross Over
             */
            var checkVerticalCrossOver = function()
            {
                var goingUp = moving.isGoingUp();
                if( goingUp === null ) return;
                if( goingUp ) {
                    var next = moving.itemObject.clone.prevAll('.sortable--item').not('.sortable--moving').not('.sortable--clone').first();
                    if( next.length && moving.y <= next.data( 'sortable' ).positions.y ) {
                        moving.itemObject.clone.insertBefore( next );
                        moving.itemObject.moved();
                        setOffsetsOfAllItems();
                    }
                } else {
                    var next = moving.itemObject.clone.nextAll('.sortable--item').not('.sortable--moving').not('.sortable--clone').first();
                    if( next.length && moving.y >= next.data( 'sortable' ).positions.y ) {
                        moving.itemObject.clone.insertAfter( next );
                        moving.itemObject.moved();
                        setOffsetsOfAllItems();
                    }
                }
            };

            /**
             * Get Relative Coordinates
             * @param e
             * @returns {{x: number, y: number}}
             */
            var getRelativeCoordinates = function(e)
            {
                var pos = {}, offset = {}, ref;
                ref = menu.get(0).offsetParent;
                pos.x = !! e.touches ? e.touches[ 0 ].pageX : e.pageX;
                pos.y = !! e.touches ? e.touches[ 0 ].pageY : e.pageY;
                offset.left = menu.get(0).offsetLeft;
                offset.top = menu.get(0).offsetTop;
                while ( ref ) {
                    offset.left += ref.offsetLeft;
                    offset.top += ref.offsetTop;
                    ref = ref.offsetParent;
                }
                return {
                    x : pos.x - offset.left,
                    y : pos.y - offset.top,
                };
            };

            /**
             * Mover Object
             * @param itemObject
             * @param _e
             */
            var moverObject = function( itemObject, _e )
            {
                this.itemObject = itemObject;
                this.item = itemObject.item;
                this.relCords = getRelativeCoordinates(_e);
                var lastX = this.relCords.x;
                var lastY = this.relCords.y;
                var yy = this.relCords.y;
                var xx = this.relCords.x;
                var b = this.item.position().left;
                var d = this.item.position().top;
                var f = xx - b;
                var e = yy - d;
                this.y;
                this.x;

                /**
                 * Is Going Up
                 * @returns {*}
                 */
                this.isGoingUp = function()
                {
                    if( lastY === yy ) return null;
                    return lastY > yy;
                };

                /**
                 * Is Going Down
                 * @returns {*}
                 */
                this.isGoingDown = function ()
                {
                    if( lastY === yy ) return null;
                    return lastY < yy;
                };

                /**
                 * Set Cursor Positions
                 * @param _e
                 */
                this.setCursorPositions = function(_e)
                {
                    this.relCords = getRelativeCoordinates(_e);
                    lastX = xx;
                    lastY = yy;
                    yy = this.relCords.y;
                    xx = this.relCords.x;
                };

                /**
                 * Calculate
                 */
                this.calculate = function()
                {
                    this.y = yy - e;
                    this.x = xx - f;
                };

                /**
                 * Reposition
                 */
                this.reposition = function()
                {
                    this.item.css({
                        top : this.y + 'px',
                        left : this.x + 'px'
                    });
                };

                /**
                 * Drop
                 */
                this.drop = function()
                {
                    itemObject.dropping();
                    moving = null;
                };

                this.calculate();


            };

            /**
             * On Mouse Move Handler
             */
            var onMouseMoveHandler = function(e)
            {
                if( ! moving ) return;
                moving.setCursorPositions(e);
                moving.calculate();
                moving.reposition();
                checkVerticalCrossOver();
                checkHorizontalTabbing();
            };

            /**
             * Bind Events
             */
            var bindEvents = function()
            {
                menu.on( 'mousemove.sortable', onMouseMoveHandler );
                menu.on( 'mouseup.sortable', function(){
                    if( moving ) {
                        moving.drop();
                        sortItemsAfterDrop();
                    }
                });
            };

            /**
             *
             * @param elm
             * @returns {*}
             */
            var createClone = function( elm )
            {
                  return elm.clone().addClass( 'sortable--clone' ).css( 'opacity', '0.5' );
            };

            /**
             * Handle Moving Of Item
             * @param obj
             */
            var handleMovingOfItem = function( obj, e )
            {
                obj.onMove();
                var position = obj.item.position();
                obj.clone = createClone( obj.item );
                obj.clone.insertBefore( obj.item );
                obj.item.addClass( 'sortable--moving' ).css({
                    position : 'absolute',
                    top : position.top + 'px',
                    left : position.left + 'px',
                    zIndex : '999999'
                });
                moving = new moverObject( obj, e );
                setOffsetsOfAllItems();
            };

            /**
             * Item Object
             * @param _item
             */
            var item = function( _item )
            {

                var obj = this;

                this.item = _item;

                this.id = Number( this.item.attr( 'data-row-id' ) );

                this.parent_id = Number( this.item.attr( 'data-row-parent-id' ) );

                this.indent = Number( this.item.attr( 'data-row-indent' ) );

                this.order = Number( this.item.attr( 'data-row-order' ) );

                this.maxIndent = 0;

                this.clone = null;

                this.children = [];

                this.startPositions = {
                    x : this.item.position().left,
                    y : this.item.position().top,
                    height : this.item.outerHeight()
                };

                this.positions = this.startPositions;

                var beforeMove = this.indent;

                /**
                 * Handle Mouse Down On Item
                 * @param e
                 */
                var handleMouseDownOnItem = function(e)
                {
                    if( e.which !== 1 || moving ) return;
                    handleMovingOfItem( obj, e );
                };

                /**
                 * Remove
                 */
                this.remove = function()
                {
                    var index = items.indexOf( this );
                    if ( index > -1 ) {
                        items.splice( index, 1 );
                    }
                };

                /**
                 * Moved - Action
                 */
                this.moved = function()
                {
                    this.setMaxIndent();
                };

                /**
                 * Indented - Action
                 */
                this.indented = function()
                {
                    this.reIndentClone();
                };

                /**
                 * Dropping - Action
                 */
                this.dropping = function()
                {
                    this.item.removeClass( 'sortable--moving' ).removeAttr('style');
                    this.clone.replaceWith( this.item );
                    this.clone = null;
                    this.reIndent();
                    this.setMaxIndent();
                    this.releaseChildren();
                    setParentToAll();
                    setOrderToAll();
                };

                /**
                 * Release Children
                 */
                this.releaseChildren = function()
                {
                    var diff = this.indent - beforeMove;
                    var prev = this.item;
                    if( this.children ) {
                        this.children.forEach( function( itemObject ) {
                            itemObject.clone.insertAfter( prev );
                            itemObject.item = itemObject.clone;
                            itemObject.clone = null;
                            itemObject.indent += diff;
                            itemObject.reIndent();
                            itemObject.item.data( 'sortable', itemObject );
                            itemObject.bind();
                            prev = itemObject.item;
                        });
                        this.children = [];
                    }
                };

                /**
                 * On Move
                 */
                this.onMove = function()
                {
                    beforeMove = this.indent;
                    if( this.hasChildren() ) {
                        this.storeChildren();
                    }
                };

                /**
                 * Store Children
                 */
                this.storeChildren = function()
                {
                    var _breached = false;
                    var _this = this;
                    this.item.nextAll(':not(.sortable--moving)').each(function() {
                       var _object = $(this).data( 'sortable' );
                       if( _object.indent <= _this.indent ) {
                           _breached = true;
                       }
                        if( ! _breached ) {
                           _object.clone = $(this).clone();
                            _this.children.push( _object );
                            $(this).remove();
                        }
                    });
                };

                /**
                 * Has Children
                 * @returns {boolean}
                 */
                this.hasChildren = function()
                {
                    if( this.item.next().length ) {
                        return this.item.nextAll(':not(.sortable--moving)').eq(0).data( 'sortable' ).indent > this.indent;
                    }
                    return false;
                };

                /**
                 * Re-indent
                 */
                this.reIndent = function()
                {
                    this.item.css({ paddingLeft : options.indentSize * this.indent });
                };

                /**
                 * Re Indent Clone
                 */
                this.reIndentClone = function()
                {
                    this.clone.css({ paddingLeft : options.indentSize * this.indent });
                };

                /**
                 * Get Workable Item
                 * @returns {null}
                 */
                this.getWorkableItem = function()
                {
                    return this.clone === null ? this.item : this.clone;
                };

                /**
                 * Set Parent
                 */
                this.setParent = function()
                {
                    var prevItems = this.getWorkableItem().prevAll('.sortable--item:not(.sortable--moving)');
                    var parent = null;
                    var _this = this;
                    prevItems.each( function(){
                        if( parent === null && _this.indent > $(this).data( 'sortable' ).indent ) {
                            parent = $(this).data( 'sortable' ).id;
                        }
                    });
                    this.parent_id = Number( parent );
                };

                /**
                 * Set Max Indent
                 */
                this.setMaxIndent = function()
                {
                    this.maxIndent = 0;
                    if( this.getWorkableItem().prev().length ) {
                        this.maxIndent = getMaxIndentFor( this );
                        if( this.indent > this.maxIndent ) {
                            this.indent = this.maxIndent;
                        }
                        if( this.clone ) {
                            this.reIndentClone();
                        } else {
                            this.reIndent();
                        }
                    }
                };

                /**
                 * Bind
                 */
                this.bind = function()
                {
                    this.item.on( 'mousedown.sortable', options.dragHandle, handleMouseDownOnItem );
                };

                /**
                 * Set Order
                 */
                this.setOrder = function()
                {
                    this.order = this.item.index();
                };

                this.item.data( 'sortable', this );
                this.setMaxIndent();
                this.reIndent();
                this.item.addClass( 'sortable--item' );
                this.bind();

            };

            /**
             * API
             * Create a publicly accessible class
             * @param _menu
             */
            var api = function( _menu )
            {
                this.menu = _menu;

                /**
                 * Populate Items
                 * Flush out the current items an create a new item instance
                 */
                this.populateItems = function()
                {
                    items = [];
                    $( '> li:not(.empty)', this.menu ).each(function() {
                       items.push( new item( $(this) ) );
                    });
                };

                /**
                 * Add Item
                 * @param _item
                 */
                this.addItem = function( _item )
                {
                    items.push( new item( _item ) );
                };

                /**
                 * Serialize Data
                 */
                this.serializeData = function() {
                    var _items = [];
                    items.forEach( function( itemObject ) {
                        _items.push({
                            id : itemObject.id,
                            parent_id : itemObject.parent_id,
                            order : itemObject.order,
                            indentation : itemObject.indent
                        });
                    });
                    return JSON.stringify( _items );
                };

                /**
                 * Re Orders
                 */
                this.reOrder = function()
                {
                    setOrderToAll();
                };

                /**
                 * Re Set Height
                 */
                this.reSetHeight = function()
                {
                    menu.css( 'height', 'auto' );
                    menu.height( menu.outerHeight() );
                };

            };

            var _api = new api( menu );
            menu.css({ position : 'relative' });

            if( ! _options.collapsibleMenu ) {
                menu.height( menu.outerHeight() );
            }

            _api.populateItems();
            bindEvents();
            return _api;

        };

        if( _options.bodyScrollFix ) {
            $( 'body' ).css( 'overflow', 'visible' );
        }

        return $(this).each( function() {

            $(this).data( 'sortable-api', new Sortable( this, _options ) );

        });

    };

})( window, jQuery );
